import { createSelector, Selector } from 'reselect'

import { MasterDataState } from '../model/masterData.model'

import { RootState } from '~/core/store/root.reducer'

type GetMasterData = Selector<RootState, MasterDataState>

const getMasterData: GetMasterData = (state) => state.masterData

export const selectDocumentTypes = createSelector(
  getMasterData,
  (masterData) => masterData.data.documentTypes,
)

export const selectNationalities = createSelector(
  getMasterData,
  (masterData) => masterData.data.nationalities,
)

export const selectSegments = createSelector(
  getMasterData,
  (masterData) => masterData.data.segments,
)

export const selectLanguages = createSelector(
  getMasterData,
  (masterData) => masterData.data.languages,
)

export const selectBillingTypes = createSelector(
  getMasterData,
  (masterData) => masterData.data.billingTypes,
)

export const selectMasterDataLoading = createSelector(
  getMasterData,
  (masterData) => masterData.loading,
)

export const selectMasterDataError = createSelector(
  getMasterData,
  (masterData) => !!masterData.errorCode,
)

export default getMasterData
